// https://blog.logrocket.com/how-to-use-axios-vue-js/

import { useGlobalConfig } from "@/composables/useGlobalConfig";
import axios from "axios";
import type { App } from "vue";

const { assistantId, settingsId } = useGlobalConfig();

export default {
  install: (app: App) => {
    app.config.globalProperties.$axios = axios.create({
      baseURL: import.meta.env.VITE_BACKEND_URL,
      withCredentials: true,
      withXSRFToken: true,
      headers: {
        "X-Assistant-Id": assistantId.value,
        "X-Settings-Id": settingsId.value,
      },
    });
  },
};
